// extracted by mini-css-extract-plugin
export var section = "styles-module--section--869xm";
export var container = "styles-module--container--S3Ksr";
export var meta = "styles-module--meta--cuDVB";
export var item = "styles-module--item--GVkLt";
export var title = "styles-module--title--ykRaD";